import { Button } from "@package/subframe/components/Button";
import { IconWithLogoBackground } from "@package/subframe/components/IconWithLogoBackground";

import { Dialog, DialogContent } from "@/components/ui/dialog";

interface FollowUpActionSuccessDialogProps {
  open: boolean;
  sourceLabel: string | null;
  onReturnToSource: () => void;
  onReturnToDashboard: () => void;
}

export function FollowUpActionSuccessDialog({
  open,
  sourceLabel,
  onReturnToSource,
  onReturnToDashboard,
}: FollowUpActionSuccessDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="p-0 sm:max-w-[448px]"
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="flex w-full flex-col items-center gap-8 px-8 py-8">
          <div className="flex w-full flex-col items-center gap-6">
            <IconWithLogoBackground variant="success" size="x-large" />
            <span className="text-heading-2 font-heading-2 text-primary-navy-800">
              Follow-up action created
            </span>
            <span className="text-body font-body text-subtext-color text-center px-8">
              Your follow-up action has been created and assigned. Where would
              you like to go next?
            </span>
          </div>
          <div className="flex w-full flex-col gap-3">
            {sourceLabel ? (
              <>
                <Button
                  className="h-12 w-full"
                  variant="brand-primary"
                  size="large"
                  onClick={onReturnToSource}
                >
                  {sourceLabel}
                </Button>
                <Button
                  className="h-12 w-full"
                  variant="neutral-secondary"
                  size="large"
                  onClick={onReturnToDashboard}
                >
                  Return to Dashboard
                </Button>
              </>
            ) : (
              <Button
                className="h-12 w-full"
                variant="brand-primary"
                size="large"
                onClick={onReturnToDashboard}
              >
                Return to Dashboard
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
